module.exports = __webpack_public_path__ + "img/joinus-3.5a51b9ce.png";